export default __webpack_public_path__ + "static/media/noypioyat-bg.1bdb91a2.jpg";